module.exports = __webpack_public_path__ + "static/2-44c22cfb8376d76ff3395b5f44444e1b.jpg";